/**
 * Simple GROQ template tag that re-exports the string its given. This tag's
 * types does not let you pass in any expressions.
 */
function groq(strings, ...values) {
  return strings.reduce((acc, next, i) => `${acc}${next}${values[i] || ''}`, '');
}

/**
 * Takes in any sanity client that implements the
 * [`fetch`](https://www.sanity.io/docs/js-client#performing-queries) method and
 * returns a configure function. When that configure function is called, a
 * wrapped client with a new method `query` will be returned.
 *
 * The purpose of this function is to decorate an existing sanity client with
 * an API that's compatible with the `@sanity-codegen/groq-codegen`'s query
 * extraction. @see `@sanity-codegen/groq-codegen` for more info.
 *
 * > NOTE: the two separate functions exist as a work around for TypeScript's
 * lack of partial type parameter inference.
 * [See here](https://stackoverflow.com/a/45514257/5776910)
 */
function wrapClient(client) {
  function configureClient() {
    function query( // the query key is only used for typescript meta programming and is not
    // actually used during runtime
    _queryKey, groqQuery, queryParams) {
      return client.fetch(groqQuery, queryParams);
    }

    const wrapped = Object.defineProperty(client, 'query', {
      get: () => query
    });
    return wrapped;
  }

  return configureClient;
}

export { groq, wrapClient };
//# sourceMappingURL=index.esm.js.map
